/**
 * File: McqController.js
 * Project: educore
 * Created Date: 2018-12-07
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import imagePopup from '../views/popup/imagePopup.html'
import passagePopup from '../views/popup/passagePopup.html'
import textPopup from '../views/editor.html';

class McqController {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, CQuesConst, CONSTANTS, $mdDialog, $mdMedia, uploadService,$sce) {
        //On init function
        this.$onInit = () => {
                $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
                $rootScope.title = "Activity"
                if (!$rootScope.isLoggedIn) {
                    $state.go("login", {}, {
                        reload: true
                    })
                }
            }
            //On destroy function
        this.$onDestroy = () => {}
        let self = this;
        /********** BASIC DETAILS *********/
        let UPLOAD_URL = CONSTANTS.SERVER_UPLOAD
        let userId = localStorageService.get("user_id")
        let USER_PATH = userId + "/question/"
        let schoolId = localStorageService.get("school_id")
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
        let QUESTION_IMG_SUPPORT_FORMAT = CQuesConst.QUESTION_IMG_SUPPORT_FORMAT
        let GET_ALL_PASSAGES = CQuesConst.API_GET_ALL_PASSAGES
        let GET_PASSAGE = CQuesConst.API_GET_PASSAGE
        let SAVE_URL = CQuesConst.API_CREATE_MCQ
        $scope.questionImage = [];
        $scope.descImage = [];
        $scope.explanationImage = [];
        $scope.isLatex = false
        $scope.content_editor_id = userId;
        $scope.options = [];
        $scope.question = "";
        /******* LIMIT FOR QUSTION CREATION *******/
        $scope.option_limit = CQuesConst.OPTION_LIMIT;
        $scope.ques_desc_limit = CQuesConst.QUES_DESC_LIMIT;
        $scope.explain_limit=CQuesConst.ANS_EXPLANATION_LIMIT;
        $scope.isNotComposed = false

        this.alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
        this.optionColors = ["#f3c301", "#2ab4bf", "#e74f5b", "#1bbc9d"];
        $scope._MCQ = {}
        $scope._MCQ.is_single_pattern = true
        var calIndex = function(index, length) {
            if (index >= length) {
                if ((index - length) >= length)
                    return calIndex(index - length, length)
                else
                    return index - length;
            } else
                return index;
        }

        let editQuestion = $scope.$parent.editQuestion
        if (editQuestion) {
            $scope._id = editQuestion._id;
            $scope.question = editQuestion.qn_desc;
            $scope.isNotComposed = true
            $scope.used_editor_html = $sce.trustAsHtml(editQuestion.qn_desc);
            $scope._MCQ.is_single_pattern = false
            if(editQuestion.is_single_pattern){
                $scope._MCQ.is_single_pattern = true
            }
            $scope.isLatex = editQuestion.isLatex;
            $scope.questionImage = [];
            if (editQuestion.questionImg) {
                if (Array.isArray(editQuestion.questionImg)) {
                    $scope.questionImage = editQuestion.questionImg
                } else {
                    $scope.questionImage.push(editQuestion.questionImg)
                }
            }
            if (editQuestion.choice && editQuestion.choice.length > 0) {
                _.each(editQuestion.choice, function(ch) {
                    var colorIndex = calIndex($scope.options.length, 4);
                    let optionImage = []
                    if (ch.optImage) {
                        if (Array.isArray(ch.optImage)) {
                            optionImage = ch.optImage
                        } else {
                            optionImage.push(ch.optImage)
                        }
                    }
                    $scope.options.push({
                        'caption': ch.tag,
                        'color': self.optionColors[colorIndex],
                        'value': ch.desc,
                        'hint': ch.hint,
                        'correct': ch.correct,
                        'optImage': optionImage
                    })
                })
            }
            $scope.created_dt = editQuestion.created_dt;
            $scope.content_editor_id = editQuestion.content_editor_id;
            $scope.selectedPassage_id = editQuestion.passage_id;
            if ($scope.selectedPassage_id) {
                $scope.selectedPassage = editQuestion.passage_detail;
            }
        } else {
            for (var i = 0; i < 4; i++) {
                let option = {
                    caption: self.alphabets[i],
                    color: self.optionColors[i],
                    optImage: []
                }
                $scope.options.push(option)
            }
        }
        checkCorrectOptionOnEdit()
        //TO SET PASSAGE LIST
        var passageCallback = (resultObj) => {
            $scope.isPassagePresent = false;
            $scope.passages = []
            if (resultObj && resultObj.result && resultObj.result.data) {
                var result = resultObj.result.data.passage ? resultObj.result.data.passage : []
                if (result) {
                    if (result.length > 0) {
                        $scope.isPassagePresent = true;
                        _.each(result, function (eachPas) {
                            if ($scope.selectedPassage_id === eachPas._id) {
                                eachPas["isSelected"] = true
                            } else {
                                eachPas["isSelected"] = false
                            }
                        })
                        $scope.passages = result
                    }
                    _.defer(() => { $scope.$apply() })
                }
            }
        }
        let authoring = {
            curriculum_id: $scope.$parent.curriculum_id,
            class_id: $scope.$parent.class_id,
            subject_id: $scope.$parent.subject_id,
            school_id: schoolId,
            user_id: userId
        }
        authService.callAPI(GET_ALL_PASSAGES, "POST", authoring, passageCallback)


        $scope.paste = function(e) {
            e.preventDefault();
            return false
        }

        let imageViewType = "";
        let optIndex = -1;

        $scope.addOption = function() {
            var alphaIndex = calIndex($scope.options.length, 26);
            var colorIndex = calIndex($scope.options.length, 4);
            var option = {
                'caption': self.alphabets[alphaIndex],
                'color': self.optionColors[colorIndex],
                'optImage': []
            }
            $scope.options.push(option)
        }
        $scope.removeOption = function(index) {
            if ($scope.options.length == 2) {
                return false;
            } else {
                var tempOptions = [];
                angular.copy($scope.options, tempOptions)
                for (var i = 0; i < $scope.options.length; i++) {
                    if (i > index) {
                        $scope.options[i].caption = tempOptions[i - 1].caption;
                        $scope.options[i].color = tempOptions[i - 1].color;
                    }
                }
                $scope.options.splice(index, 1)
            }
        }

        //Question desc with latex
        var mathFieldSpan = document.getElementById('math-field');
        mathFieldSpan.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
        var MQ = MathQuill.getInterface(2);
        if ($scope.question) {
            mathFieldSpan.textContent = $scope.question
        }
        var mathField = MQ.MathField(mathFieldSpan, {
            spaceBehavesLikeTab: false,
            restrictMismatchedBrackets: true,
            handlers: {
                edit: function() {
                    $scope.question = mathField.latex()
                }
            }
        });


        //Invokes after the option elements loaded
        $scope.optionsLoaded = function(option) {
            var optionFieldSpan = document.getElementsByClassName('option-field');
            _.each(optionFieldSpan, function(spanElement) {
                spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
                if (option.value) {
                    spanElement.textContent = option.value
                }
                var optionField = MQ.MathField(spanElement, {
                    spaceBehavesLikeTab: false,
                    restrictMismatchedBrackets: true,
                    handlers: {
                        edit: function() {
                            option.value = optionField.latex()
                        }
                    }
                });
            })
        }

        //Invokes after the hint elements loaded
        $scope.hintsLoaded = function(option) {
            var hintFieldSpan = document.getElementsByClassName('hint-field');
            _.each(hintFieldSpan, function(spanElement) {
                spanElement.className = 'ng-pristine ng-valid md-input ng-empty ng-touched'
                if (option.hint) {
                    spanElement.textContent = option.hint
                }
                var hintField = MQ.MathField(spanElement, {
                    spaceBehavesLikeTab: false,
                    restrictMismatchedBrackets: true,
                    handlers: {
                        edit: function() {
                            option.hint = hintField.latex()
                        }
                    }
                });
            })
        }


        //PREVENT PASTE FUNCTIONALITY
        $scope.paste = function(e) {
            e.preventDefault();
            return false
        }

        //Image upload for question
        $scope.questionImgUpload = function(file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function(fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function(result) {
                        if (result.url) {
                            $scope.questionImage.push(result.url)
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }


        //Image upload for Desc
        $scope.optionImgUpload = function(file, opt) {
            let supportedFrmts = QUESTION_IMG_SUPPORT_FORMAT
            _.each(file, function(fileObj) {
                let extValue = fileObj.name.split('.').pop().toLowerCase();
                if (_.contains(supportedFrmts, extValue)) {
                    uploadService.uploadCheckService(fileObj, UPLOAD_URL, USER_PATH, function(result) {
                        if (result.url) {
                           let index = -1;
                            _.each($scope.options, function(key, val) {
                                if (key.caption === opt.caption) {
                                    index = val;
                                }
                            })
                            $scope.options[index].optImage.push(result.url)
                        }
                    })
                } else {
                    toastr.error("Please select the supported format jpg, jpeg, png")
                    fileObj = {}
                }
            })
        }

        //DIALOG CONTROLLER FOR IMAGE
        var imageDialogCtrl = function($scope, $mdDialog, imageViewType, imageDetails) {
            $scope.fileUrl = PREVIEW_URL
            $scope.isPassage = false;
            $scope.title = imageDetails.title;
            $scope.imageArray = imageDetails.images;
            $scope.isPassage = imageDetails.isPassage ? imageDetails.isPassage : false

            $scope.deleteImage = function(imageIndex) {
                $scope.imageArray.splice(imageIndex, 1)
            }
            $scope.cancelDialog = function() {
                $mdDialog.cancel();
                if (imageViewType === 'question') {
                    $scope.questionImage = $scope.imageArray
                } else if (imageViewType === 'explan') {
                    $scope.explanationImage = $scope.imageArray
                } else if (imageViewType === 'answer') {
                    $scope.descImage = $scope.imageArray
                }
                $scope.imageArray = []
            };
        }
        $scope.cancelSelectedPasssage = function () {

            $scope.selectedPassage = null
            _.each($scope.passages, function (eachPas) {
                eachPas.isSelected=false
            })
          }
        //Open dialog to view image
        $scope.openDialog = (imageType, index, desc) => {
            let imageDetails;
            if (imageType === 'question') {
                imageDetails = {
                    title: "MCQ - Question Image",
                    images: $scope.questionImage
                }
            } else if (imageType === 'answer') {
                $scope.imageArray = $scope.options[index].optImage;
                optIndex = index;
                imageDetails = {
                    title: "MCQ - Answer Image",
                    images: $scope.imageArray
                }
            } else if (imageType === 'passage') {
                imageDetails = {
                    title: "MCQ - Passage Image",
                    images: $scope.selectedPassage.passage_image,
                    isPassage: true
                }
            }
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                locals: {
                    imageViewType: imageType,
                    imageDetails: imageDetails
                },
                template: imagePopup,
                controller: ['$scope', '$mdDialog', 'imageViewType', 'imageDetails', imageDialogCtrl],
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
        }

        var setPassage = () => {            
            $scope.selectedPassage = _.find($scope.passages,function(pas){
                return pas.isSelected
            })
        }

        //DIALOG CONTROLLER FOR PASSAGE
        var passageDialogCtrl = function ($scope, $mdDialog, passages) {
            $scope.passages = passages
            $scope.fileUrl = PREVIEW_URL
            $scope.isArray = function (obj) {
                return Array.isArray(obj);
            }
            /*
             * Function to cancel dialog to select passage
             */
            $scope.cancelPassage = function () {
                $mdDialog.cancel();
                setPassage()
            };


          
              /*
             * Function to select passage
             */
            $scope.selectPassage = function (passage_id) {
                _.each($scope.passages, function (eachPas) {
                  if (eachPas._id !=passage_id) {
                    eachPas.isSelected = false;
                  }
                })
                $scope.cancelPassage()
              }

        }


        

        

        /*
         * Function to open dialog to select passage
         */
        $scope.openPassage = () => {
            if(!$scope.passages)
            {
                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('No Passage')
                    .textContent('Passages not loaded.Try after some time.')
                    .ariaLabel('Passage Dialog')
                    .ok('Ok')
                );
            }
           else
            {
                if($scope.passages.length==0)
               {
                $mdDialog.show(
                    $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .title('No Passage')
                    .textContent('No passages added yet. Please add passage and link it')
                    .ariaLabel('Passage Dialog')
                    .ok('Ok')
                );
               }
        
           else {
                var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
                $mdDialog.show({
                    locals: {
                        passages: $scope.passages
                    },
                    template: passagePopup,
                    controller: ['$scope', '$mdDialog', 'passages', passageDialogCtrl],
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: useFullScreen
                })
            }
        }
        }
        //Adding OWQ question from UI
        $scope.$on('addMcqQuestion', function() {
            $scope.errors = {}
            let details = localStorageService.get("questionDetails")
            let question = details.question
            let activityErrorCount = details.errorCount;
            $scope.errors = {};
            let answerArr = [];

            let duplicateOptCnt = 0;

            let isCorrectAnswerExists = false;

            //Validation  
            if ($scope.question == null || $scope.question == undefined || $scope.question == "") {
                $scope.errors["qn_desc"] = "Question is required";
                activityErrorCount++;
            } else if ($scope.question.length > $scope.ques_desc_limit) {
                $scope.errors["qn_desc"] = "Question does not exceed " + $scope.ques_desc_limit + " characters";
                activityErrorCount++;
            }
            if ($scope.options) {
                _.each($scope.options, function(answer, index) {
                    if (answer.hint && answer.hint.length > $scope.explain_limit) {
                        $scope.errors["option." + index + ".hint"] = "Hint does not exceed " + CQuesConst.ANS_EXPLANATION_LIMIT + " characters"
                        activityErrorCount++;
                    }
                    if (answer.value == null || answer.value == undefined || answer.value == "") {
                        $scope.errors["option." + index + ".desc"] = "Answer is required"
                        activityErrorCount++;
                    } else if (answer.value.length > $scope.option_limit) {
                        $scope.errors["option." + index + ".desc"] = "Answer does not exceed " + CQuesConst.OPTION_LIMIT + " characters"
                        activityErrorCount++;
                    }
                    if (answer.correct)
                        isCorrectAnswerExists = true
                    if (answer.value) {
                        if (answerArr.indexOf(answer.value) === -1) {
                            answerArr.push(answer.value)
                        } else {
                            duplicateOptCnt++
                        }
                    }
                })
                if (!isCorrectAnswerExists) {
                    let str = "Select a correct answer"
                    if(!$scope._MCQ.is_single_pattern){
                        str = "Select atleast one answer"
                    }
                    $scope.errors["correctAnswer"] = str;
                    activityErrorCount++;
                }
                if (duplicateOptCnt > 0) {
                    $scope.errors['duplicateAns'] = "options are repeated."
                    activityErrorCount++;
                }
            }
            let choicesData = []
            _.each($scope.options, function(optionObj, index) {
                let option = {
                    "tag": optionObj.caption,
                    "desc": optionObj.value,
                    "correct": optionObj.correct,
                    "optImage": optionObj.optImage,
                    "hintImage": ""
                }
                if (optionObj.correct) {
                    option["hint"] = optionObj.hint
                    option['curr'] = 1
                } else {
                    option["correct"] = false
                    option["hint"] = optionObj.hint
                    option['curr'] = 0
                }
                choicesData.push(option)
            })
            self.Cans = 0
            self.NcAns = 0
            _.each(choicesData, function(eachChoice) {
                if (eachChoice.curr == "1") {
                    self.Cans++
                } else {
                    self.NcAns = 0
                }
            })
            let isAllow = 1
            if ((self.Cans === 0) || (choicesData.length === self.Cans)) {
                isAllow = 0
                if (choicesData.length === self.Cans) {
                    isAllow = 2
                }
            }
            
            if (activityErrorCount === 0) {
                $scope.$parent.isSaveClicked = true;
                let obj = {
                        "_id": $scope._id,
                        "question_theme_id": question.theme._id,
                        "question_theme_name": question.theme.name,
                        "choice": choicesData,
                        "descImage": $scope.descImage,
                        "explanation": $scope.explanation,
                        "explanationImage": $scope.explanationImage,
                        "strand": question.strand,
                        "tag": question.tag,
                        "wave": question.wave,
                        "qn_desc": '' + $scope.question,
                        "isLatex": $scope.isLatex,
                        "level": question.level,
                        "subject_id": question.subject_id,
                        "school_id": question.school_id,
                        "questionImg": $scope.questionImage,
                        "session_id": question.session_id,
                        "batch_id": question.batch_id,
                        "class_id": question.class_id,
                        "curriculum_id": question.curriculum_id,
                        "xlink": question.link_theme,
                        "cognitive_skills": question.cognitive_skill,
                        "isNotAddToQp": question.isNotAddToQp,
                        "is_traditional_activity": question.is_traditional_activity,
                        "qp_id": question.qp_id,
                        "created_dt": $scope.created_dt,
                        "content_editor_id": $scope.content_editor_id,
                        "user_id": userId,
                        'activity_id': question.activity_id,
                        "passage": $scope.selectedPassage,
                        "teaching_plan_id": question.teaching_plan_id,
                        is_single_pattern : $scope._MCQ.is_single_pattern
                }
                //SAVE CALL
                authService.callAPI(SAVE_URL, "POST", obj, function (resObj) {
                    let result = resObj.result
                    if (result && result.data && result.data.success) {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        $rootScope.resetValues()
                        if (question.is_traditional_activity) {
                            $state.go('formatQuestion', {
                                qpId: question.qp_id
                            })
                            toastr.success("Question Saved successfully");
                        }else if(question.teaching_plan_id !== undefined && question.teaching_plan_id !== null && question.teaching_plan_id !== ""){
                            $state.go('formatQp', {
                                resourceId: question.activity_id
                            })
                            toastr.success("Question Saved successfully");
                        } else {
                            if (result.data.isExists) {
                                toastr.success("Question already exists");
                            } else {
                                toastr.success("Question Saved successfully");
                                $rootScope.setSearchFieldSession()
                            }
                        }
                    } else {
                        $rootScope.setHideSaveButton(false)
                        $rootScope.setLoader(false)
                        toastr.error("Network Error")
                    }
                    _.defer(() => { $scope.$apply() })
                })
            } else {
                $rootScope.setHideSaveButton(false)
                $rootScope.setLoader(false)
                toastr.error("Please fill all mandatory fields")
            }
        })

        $scope.changeSelection = () => {
            let options = $scope.options
            if($scope.errors && $scope.errors["correctAnswer"]){
                $scope.errors["correctAnswer"] = ''
            }
            for (let o = 0; o < options.length; o++) {
                options[o]['correct'] = false
                options[o]['isChecked'] = false
            }
            let string = "Selected multiple answer pattern"
            if($scope._MCQ.is_single_pattern){
                string = "Selected single answer pattern"
            }
            toastr.success(string)
        }
        $scope.uncheck = (event, isChecked, index) => {
            let options = $scope.options
            if($scope._MCQ.is_single_pattern){
                for (let o = 0; o < options.length; o++) {
                    options[o]['isChecked'] = false
                    if(o == index){
                        if(options[o]['isChecked'] !== event.target.value){
                            options[o]['isChecked'] = true
                            options[o]['correct'] = true
                        }
                    }else{
                        options[o]['isChecked'] = false
                        options[o]['correct'] = false
                    }
                }
            }
        }
        function checkCorrectOptionOnEdit(){
            if($scope._MCQ.is_single_pattern){
                let options = $scope.options
                for (let o = 0; o < options.length; o++) {
                    if(options[o]['correct']){
                        options[o]['isChecked'] = true
                    }
                }
                console.log(options)
            }
        }

        $scope.viewTextAngular = function () {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && $scope.customFullscreen;
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'parentScope', editorLACtrl],
                locals: {
                    parentScope : $scope
                },
                template: textPopup,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                // fullscreen: useFullScreen
            })
            
        }
        $scope.setQuestionFromEditor = function (editor_value){
            $scope.question = editor_value
            $scope.used_editor = true
            $scope.isNotComposed = true
            let used_editor = document.getElementById('used_editor')
            $scope.used_editor_html = $sce.trustAsHtml(editor_value);
            // used_editor.append(editor_value)
            console.log(used_editor)
        }
        function resetFn(){
            $scope.isNotComposed = false
            $scope.question = ''
            $scope.used_editor_html = ''
        }
        $scope.resetQuestion = function (){
            var confirm = $mdDialog.confirm()
                .title('Remove')
                .textContent('This will remove question from the input, If you want to edit use editor')
                .ariaLabel('Lucky day')
                .ok('Remove')
                .cancel('Dont delete');

            $mdDialog.show(confirm).then(function() {
                resetFn()
            }, function(f, r) {
            });
        }
        // $scope.uncheck = (event, isChecked, index) => {
        //     let options = $scope.options
        //     if($scope._MCQ.is_single_pattern){
        //         for (let o = 0; o < options.length; o++) {
        //             options[o]['isChecked'] = false
        //             if(o == index){
        //                 if(options[o]['isChecked'] !== event.target.value){
        //                     options[o]['isChecked'] = true
        //                     options[o]['correct'] = true
        //                 }
        //             }else{
        //                 options[o]['isChecked'] = false
        //                 options[o]['correct'] = false
        //             }
        //         }
        //     }
        // }
    }
}
class editorLACtrl {
    constructor($scope, $mdDialog, parentScope) {
        Simditor.locale = 'en-US';
        var editor = undefined
        angular.element(document).ready(function () {
            $scope.editor = {}
            editor = new Simditor({
                textarea: $('#editor'),
                placeholder: '',
                params: {},
                upload: false,
                tabIndent: true,
                toolbar: [
                    'title',
                    'bold',
                    'italic',
                    'underline',
                    'strikethrough',
                    'fontScale',
                    'color',
                    'ol' ,      
                    'ul'  ,          
                    'blockquote',
                    'code',         
                    'table',
                    'link',
                    // 'image',
                    'hr',           
                    'indent',
                    'outdent',
                    'alignment'
                ],
                toolbarFloat: true,
                toolbarFloatOffset: 0,
                toolbarHidden: false,
                pasteImage: false,
                cleanPaste: false,
                codeLanguages : [{ name: 'Erlang', value: 'erlang' },]
                //optional options
            });
            if(parentScope.question){
                editor.setValue(parentScope.question)
            }
        });
        $scope.saveContent = (desc) => {
            console.log(desc)
            console.log($scope.editor)
            let editor_value = editor.getValue()
            if(!editor_value){
                toastr.error("Please enter question")
                return false
            }
            parentScope.setQuestionFromEditor(editor_value)
            $mdDialog.hide();
        }
        $scope.closeEditor = () => {
            $mdDialog.hide();
        }
    }
}
export default McqController;



// WEBPACK FOOTER //
// ./src/app/createQuestion/controllers/mcqController.js